export type Uuid = string;

export type DateString = string;

export type Nullable<T> = T | null;

export type ApiResponseBody<T> = {
  data: T;
  error?: Record<string, string>;
  hasData?: boolean;
  hasError?: boolean;
};

export type ApiErrorResponseBody = {
  error: ApiError;
};

export type ApiError = {
  code: string;
  message: string;
  errors?: Array<{ message: string }>;
};

export type ApiResponseBodyPaginationFields = {
  currentItemCount: number;
  itemsPerPage: number;
  startIndex: number;
  totalItems: number;
  pageIndex: number;
  totalPages: number;
};

export type PaginatedBody<T> = ApiResponseBodyPaginationFields & {
  items: T[];
};

export type PaginatedApiResponseBody<T> = ApiResponseBody<PaginatedBody<T>>;

export type PaginationSearchParams = {
  itemsPerPage?: number;
  pageIndex?: number;
};

export type SearchQuery = {
  searchQuery?: string;
};

export type UseQueryConfig = {
  enabled?: boolean;
};

export type SortOrderQuery<O = string> = {
  orderBy?: O;
  asc?: boolean;
};

export type PaginationFilterType<T, O = string> = PaginationSearchParams & SearchQuery & SortOrderQuery<O> & Partial<T>;

type PathSegments<Path extends string> = Path extends `${infer SegmentA}/${infer SegmentB}`
  ? ParamOnly<SegmentA> | PathSegments<SegmentB>
  : ParamOnly<Path>;

type ParamOnly<Segment extends string> = Segment extends `:${infer Param}` ? Param : never;

export type RouteParams<Path extends string> = {
  [Key in PathSegments<Path>]: string;
};

export type CurlyToColon<S extends string> = S extends `${infer Start}{${infer Param}}${infer Rest}`
  ? `${Start}:${Param}${CurlyToColon<Rest>}`
  : S;

export type Location = {
  id: Uuid;
  country: string;
  region: string;
  regionId: string;
  addressLine: string;
  state: string;
  city: string;
  postalCode: string;
  timezone: string;
  latitude: number;
  longitude: number;
};

export type LocationLike = Pick<Location, 'state' | 'country'>;

export type EmployeeLocation = Omit<Location, 'region' | 'regionId' | 'state'> & {
  region?: string | null;
  regionId?: string | null;
  state: string | null;
};

export enum LastCertificationAtHubStatusType {
  NotLast = 'NotLast',
  Last = 'Last',
  NotLastButBecomeLast = 'NotLastButBecomeLast',
  LastWithNextSoon = 'LastWithNextSoon',
}
